import { render, staticRenderFns } from "./ModalFileManager.vue?vue&type=template&id=4f997d0f&"
import script from "./ModalFileManager.vue?vue&type=script&lang=js&"
export * from "./ModalFileManager.vue?vue&type=script&lang=js&"
import style0 from "./ModalFileManager.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports